import { TFunction } from 'i18next';
import { SsoIntegration, SsoIntegrationStatusEnum } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onActivate: (v?: SsoIntegration) => void;
  onDeactivate: (v?: SsoIntegration) => void;
  onEdit: (v?: SsoIntegration) => void;
  onView: (v?: SsoIntegration) => void;
  onDelete: (v?: SsoIntegration) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsMenu({
  onActivate,
  onDeactivate,
  onEdit,
  onView,
  onDelete,
  t,
}: ActionsMenuArgs): NavItem<SsoIntegration>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item?: SsoIntegration) => onView(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      onClick: (item?: SsoIntegration) => onEdit(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'activate-action',
      title: t('activate'),
      onClick: (item?: SsoIntegration) => onActivate(item),
      leftIcon: Icons.activate,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item?: SsoIntegration) =>
        item?.status !== SsoIntegrationStatusEnum.Active,
    },
    {
      id: 'deactivate-action',
      title: t('deactivate'),
      onClick: (item?: SsoIntegration) => onDeactivate(item),
      leftIcon: Icons.deactivate,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item?: SsoIntegration) =>
        item?.status === SsoIntegrationStatusEnum.Active,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: SsoIntegration) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
    },
  ];
}
